module.exports = __webpack_public_path__ + "img/5fb77bb.jpg";